import React from 'react';
import {useHistory, useRouteMatch} from 'react-router-dom';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import {ORDER, ORDER_SOURCE} from 'helpers/constants/orders_v2';
import Dialog from '@material-ui/core/Dialog';
import DialogContainer from 'components/DialogContainer/styles';
import DialogTitle from 'components/DialogTitle/styles';
import {DialogSubTitle} from 'components/DialogSubTitle/styles';
import DialogBody from 'components/DialogBody/styles';
import {ButtonPrimary} from 'components/buttons';
import {DialogAction} from 'routes/App/dashboard/styles';
import ImgRefund from 'assets/img-refund.svg';
import {RefundConfirmationImg} from 'routes/App/ordersV2/OrderDetails/Refund/Modals/styles';
import {ORDER_UNMOUNT} from 'store/ordersV2/orderDetails/action';
import {CLEAR_REFUND_DATA} from 'store/ordersV2/orderRefund/action';

const ConfirmationModal = (props) => {
  const {open, onClose, values} = props;
  const history = useHistory();
  const {params} = useRouteMatch();
  const dispatch = useDispatch();
  const order = useSelector((state) => state.orderDetailsV2Reducer.order);
  const isGrubHubRefundSuccess =
    order[ORDER.SOURCE] === ORDER_SOURCE.GRUBHUB &&
    values.refundType === 'Partial';

  const redirectToOrdersDetails = (state = {}) => {
    dispatch(ORDER_UNMOUNT());
    dispatch(CLEAR_REFUND_DATA());
    history.push(
      params.back === 'history'
        ? `/orders-v2/history/${params.id}/details`
        : `/orders-v2/active/${params.id}/details`,
      state
    );
  };

  return (
    <Dialog open={open}>
      <DialogContainer className='DialogSm Overflow'>
        <DialogTitle className='DialogTitleMarginBottom'>
          {isGrubHubRefundSuccess ? 'Refund requested' : 'Refund confirmed'}
        </DialogTitle>
        <DialogSubTitle className='textCenter mBottomLarge'>
          {isGrubHubRefundSuccess
            ? 'We will update the order once refund is confirmed by GrubHub'
            : 'The customer was refunded and a confirmation email was sent'}
        </DialogSubTitle>
        {/* {values.refundType === 'Full' || values.refundType === 'Partial' ? (
          <DialogSubTitle className='textCenter mBottomLarge'>
            Our Refund Team is currently handling your repayment claim from the
            delivery company
          </DialogSubTitle>
        ) : null} */}
        <DialogBody>
          <RefundConfirmationImg src={ImgRefund} />
          <DialogAction>
            <ButtonPrimary
              onClick={() => {
                onClose();
                redirectToOrdersDetails();
              }}
            >
              <span>OK</span>
            </ButtonPrimary>
          </DialogAction>
        </DialogBody>
      </DialogContainer>
    </Dialog>
  );
};

ConfirmationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired
};

export default ConfirmationModal;
